import React, { useState, useRef, useEffect } from "react";
import "./HomePopup.css";
//import { Globals } from "../../global/Globals";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { fetchNotification, updateNotification } from "../../services/api";
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

const HomePopup = ({ route,togglePop,notificationsLength }) => {
  const parentName = route;
  const navigate = useNavigate();
  const [isTickets, setIsTickets] = useState(false);
  const { Globals } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const popupRef = useRef(null);
  const notificationRef = useRef(null);
  const profileRef = useRef(null);
  const [data, setData] = useState([]);
  const toggleTickets = () => setIsTickets(!isTickets);
  const togglePopup = () => setIsOpen(!isOpen);
  const toggleNotification = () => setIsNotificationOpen(!isNotificationOpen);
  const [clickCount, setClickCount] = useState(0);
  const toggleProfile = () => setIsProfileOpen(!isProfileOpen);
   const roleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const TicketsStyle = {
    filter:
      isTickets || route === "Tickets"
        ? "invert(3%) sepia(100%) saturate(7242%) hue-rotate(197deg) brightness(95%) contrast(107%)"
        : "none",
  };

  const FAQstyle = {
    filter:
      isOpen || route === "FAQ"
        ? "invert(3%) sepia(100%) saturate(7242%) hue-rotate(197deg) brightness(95%) contrast(107%)"
        : "none",
  };
  
  const NotificationStyle = {
    filter:
      isNotificationOpen || route === "Notification"
        ? "invert(3%) sepia(100%) saturate(7242%) hue-rotate(197deg) brightness(95%) contrast(107%)"
        : "none",
  };
  useEffect(() => {
    const getData = async () => { 
      try { 
        const result = await fetchNotification(Globals.ENDPOINT.NOTIFICATION_API,undefined,3);; 
        setData(result?.content); 
      } catch (error) { 
        console.error('Error in App component:', error); 
      } }; 
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
        setIsNotificationOpen(false);
        setIsProfileOpen(false);
      }
    };

    if (isOpen || isNotificationOpen || isProfileOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("mousedown", handleEscapeKey);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleEscapeKey);
    }
    getData(); 
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("mousedown", handleEscapeKey);
    };
    
  }, [isOpen, isNotificationOpen, isProfileOpen, notificationsLength,clickCount]);

  const handleNotificationClick = () => {
    const dashboardTab =
        roleId === "5" ? "dashboard" :
        roleId === "1" ? "admin" :
        roleId === "2" || roleId === "3" || roleId === "4" ? "internal_dashboard" :
        "dashboard";

        const proposalsTab =
        roleId === "5" ? "proposals" :
        roleId === "1" ? "internal_management" :
        roleId === "2" || roleId === "3" || roleId === "4" ? "all_proposals" :
        "";

        const otherTabs = 
         (roleId === "2" && parentName === "requests") ? "requests" :
         (roleId === "2" && parentName === "auditTrails") ? "auditTrails"  :
         (roleId === "1" && parentName === "auditTrails") ? "auditTrails"  :
        "";

    if(parentName === dashboardTab) {
        navigate('/notification', { state: { activeHeader: dashboardTab } });
    } else if (parentName === "requests") {
      navigate('/notification', { state: { activeHeader: otherTabs } });
    } else if (parentName === "auditTrails") {
      navigate('/notification', { state: { activeHeader: otherTabs } });
    } else {
        navigate('/notification', { state: { activeHeader: proposalsTab } });
    }

   //navigate('/notification')
    console.log("See All Notifications clicked");
    toggleNotification();
  };
  const updateNotification1 = async(id,read) => {
    try {
      // Uncomment these lines if you need to fetch notifications from an API.
      const response=await updateNotification(Globals.ENDPOINT.UPDATENOTIFICATION, id, read);
      console.log("Response ===> ", response);
      // filteredNotifications(filter)
      if(response.status){
        setClickCount(clickCount + 1)
      }
    } catch (error) {
      console.error('Error in App component:', error);
    }
  };
  const handleHelpVideos = () => {
    window.open(Globals.NAVPATH.VIDEOTUTORIALS, '_blank', 'noopener noreferrer');
}
// const backgroundColor = isDataAvailable ? "#dff0d8" : "#f2dede";
  return (
    <div className="Notification-Wrapper">
    <img 
        style={NotificationStyle}
        className={`Header-Popup cursor question-icon ${isNotificationOpen ? "active" : ""}`}
        onClick={toggleNotification} 
        src={Globals.IMG.BELL_ICON} 
        alt="Notifications" 
    />
    {data?.unreadCount ? <div className="notificationBadge" onClick={toggleNotification}></div> : null}
    
    {isNotificationOpen && (
        <div className="Header-Pop-Wrapper">
            <div className="Notification-Popup-Wrapper" ref={notificationRef}> 
                <h6 className="Notification-Header">
                    {Globals.NOTIFICATIONS}
                </h6>
                
      {data?.notifications?.length > 0 && data.notifications.map((notification) => (
        <div key={notification.id} onClick={() => updateNotification1(notification.notificationId,true)} className={`${notification.read ? "read" : "unread"} Header-popup-item Notification-popup-item`}>
          <div className="Notification-Popup-Header">{notification.message}</div>
          <p className="Notification-Popup-sub-heading">{notification.subMessage}</p>
        </div>
      ))}
                {data?.notifications?.length ? (
                    <div className="notification-button cursor">
                        <button
                            className="see-all-button cursor"
                            onClick={handleNotificationClick}
                        >
                            {Globals.SEE_ALL}
                        </button>
                    </div>
                ) : (
                    <div className="noNotification">
                        <img src={Globals.IMG.NOTIFICATION_ERROR_IMG} height="184" />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <h6 style={{ fontWeight: "bold" }}>{Globals.NO_NOTIFICATION}</h6>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )}
    <img
        className={`Header-Popup cursor question-icon ${isOpen ? "active" : ""}`}
        style={FAQstyle}
        src={Globals.IMG.QUESTION_ICON}
        onClick={togglePopup}
        width={20}
        height={20}
        alt="Question Icon"
    />
    {isOpen && (
        <div className="Header-popup-box" ref={popupRef}>
            <div className="Header-popup-item">
                <strong className="Help">{Globals.FAQ_DROPDOWN.HELP}</strong>
            </div>
            <hr style={{ margin: "20px 0px 10px 0px", width: "200px" }} />
            <div className="faqPopup faq-section">
                <img className="faqPopupImg" src={Globals.IMG.POPUP_QUESTION_ICON} />
                <Link className="cursor fqa-menu-text" to={Globals.NAVPATH.FAQ} state={{ parentName }}>{Globals.FAQ_DROPDOWN.FAQ}</Link>
                <Outlet />
            </div>
            {roleId !== OldGlobals.USER_ROLES.SNR_MGR && roleId !== OldGlobals.USER_ROLES.HOP &&<div className="ticketPopup ticket-section">
                <img className="ticketPopupImg" style={{width: "16px", height: "16px"}} src={OldGlobals.IMG.TICKETS_ICON} />
                <Link className="cursor ticket-menu-text" to={OldGlobals.NAVPATH.TICKETS} state={{ parentName }}>{Globals.TICKETS_FILTER.TICKETS}</Link>
                <Outlet />
            </div>}
            <div className="faqPopup hide-video-tutorials">
                <img className="faqPopupImg" src={Globals.IMG.VIDEOTUTORIALS_ICON} />
                <Link className="cursor" onClick={handleHelpVideos}/*</div>onClick={handleHelpVideos}*/>{Globals.FAQ_DROPDOWN.VIDEOTUTORIALS}</Link>
            </div>
        </div>
    )}
</div>

  );
};

export default HomePopup;
